import { ModerationModal } from '@/pages/editor/layout/ModerationModal';
import { IAgent } from '@d-id/types';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { CancelEditModal, UpgradeV2ModalDraft } from '../../components/modals';
import { Header } from './components/Header';
import { PresentersContainer } from './components/PresentersContainer';

const AgentEditorContainer = styled.div`
    background-color: ${({ theme }) => theme.colors.secondary.main};
    height: 100%;
    box-sizing: border-box;
    position: relative;
`;

interface Props {
    agent: IAgent;
}

export const AgentEditor = observer(({ agent }: Props) => {
    return (
        <>
            <AgentEditorContainer>
                <Header />

                <PresentersContainer agent={agent} />
            </AgentEditorContainer>

            <ModerationModal />
            <CancelEditModal />
            <UpgradeV2ModalDraft agent={agent} />
        </>
    );
});
